import takeScreenshotJpegBlob from './utils/screenCapture';
class Screenshot {
}
Screenshot.cropImage = (base64, { left, top, size: { width, height } }) => new Promise((resolve) => {
    const image = new Image();
    const canvas = document.createElement('canvas');
    // The source screenshot (utils/screenCapture.ts) is captured at 1:1 CSS-pixel
    // scale (canvas sized from document.body.offsetWidth/offsetHeight, no
    // devicePixelRatio multiplier) — same scale `left`/`top`/`width`/`height` are
    // measured in (getBoundingClientRect on the crop selection). Multiplying by
    // devicePixelRatio here shifted the crop to a region devicePixelRatio times
    // further from the origin than what was actually selected, on any HiDPI/Retina
    // display (i.e. always on macOS) — the crop looked like it came from a
    // different part of the page.
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    image.src = base64;
    ctx.drawImage(image, -left, -top);
    canvas.toBlob((blob) => {
        resolve(new File([blob], 'screenshot.png', { type: 'image/png' }));
    });
});
Screenshot.take = (element, method) => {
    if (method === 'userMedia')
        return Screenshot.withUserMedia();
    return Screenshot.withHtml2Canvas(element);
};
Screenshot.withUserMedia = () => new Promise((resolve, reject) => {
    takeScreenshotJpegBlob()
        .then((screenshot) => {
        resolve(URL.createObjectURL(screenshot));
    })
        .catch((err) => {
        reject(err);
    });
});
export default Screenshot;
